import React from 'react';
import male from '../../assets/male.png';
import female from '../../assets/female.png';
import { Gender } from 'apps/user/types/user.enum.type';
import Spacer from 'components/Spacer';
import { Icon, Icons } from 'components/Icon';

type Props = {
  gender: string;
  onSelect: (gender: Gender) => void;
  isRequired?: boolean;
  error?: string;
};

export default function GenderField({
  gender,
  onSelect,
  isRequired,
  error
}: Props) {
  return (
    <div>
      <div className="relative mb-2 flex items-center justify-between">
        <span className="flex items-center">
          <label className="text-[12px] font-medium text-[#353535]">
            Gender
          </label>
          {isRequired && (
            <div className="mx-2 mb-2">
              <Spacer width={3} />
              <Icon name={Icons.Required} />
            </div>
          )}
        </span>
      </div>
      <div className="mt-2 flex items-center gap-6">
        <div
          className="flex cursor-pointer flex-col items-center gap-1"
          onClick={() => onSelect(Gender.MALE)}
        >
          <img
            src={male}
            className={`rounded-full ${
              gender === Gender.MALE ? 'border border-red-600' : ''
            }`}
          />
          <p className="font-circular text-xs font-normal text-[#353535]">
            Male
          </p>
        </div>
        <div
          className="flex cursor-pointer flex-col items-center gap-1"
          onClick={() => onSelect(Gender.FEMALE)}
        >
          <img
            src={female}
            className={`rounded-full ${
              gender === Gender.FEMALE ? 'border border-red-600' : ''
            }`}
          />
          <p className="font-circular text-xs font-normal text-[#353535]">
            Female
          </p>
        </div>
      </div>
      {error && <p className="mt-2 text-xs capitalize text-red-600">{error}</p>}
    </div>
  );
}
